<ion-app>
  <!-- <ion-progress-bar  *ngIf="!isProgress"
  type="indeterminate"></ion-progress-bar> -->
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
